export default {
  root: {
    class: ['w-full'],
  },
};
